var AddressComparer = (function () {
    function AddressComparer() {
    }
    AddressComparer.prototype.areEqual = function (address1, address2) {
        return (address1 &&
            address2 &&
            address1.addressLine1 == address2.addressLine1 &&
            address1.addressLine2 == address2.addressLine2 &&
            address1.addressLine3 == address2.addressLine3 &&
            address1.postTown == address2.postTown &&
            address1.county == address2.county &&
            address1.postcode == address2.postcode &&
            address1.nationId == address2.nationId &&
            address1.country == address2.country &&
            address1.countryId == address2.countryId &&
            address1.uprn == address2.uprn);
    };
    return AddressComparer;
}());
export { AddressComparer };
export default AddressComparer;
//# sourceMappingURL=addressComparer.js.map